import { useMemo } from 'react';

import type { SortParams } from '@/constants/types';
import { useSearchParams } from 'react-router-dom';

const DEFAULT_SORT = 'updatedAt';
const DEFAULT_DIRECTION = 'desc';

export const useWorkspaceSort = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const sortParam = searchParams.get('s') || `${DEFAULT_SORT}-${DEFAULT_DIRECTION}`;

  const sortParams = useMemo(() => {
    const [key, direction] = sortParam.split('-');
    return { key, direction } as SortParams;
  }, [sortParam]);

  const onSort = (sortParams: SortParams) => {
    const { key, direction } = sortParams;
    setSearchParams((params) => {
      params.set('s', `${key}-${direction}`);
      return params;
    });
  };

  return { sortParams, onSort };
};
